export enum EmailType {
  AutomaticAdvanceInformation = 'automatic_advance_information',
  Cancellation = 'cancellation',
  CemAftersales = 'cem_aftersales',
  CemRequest = 'cem_request',
  DebugMail = 'debug_mail',
  FileForwarding = 'file_forwarding',
  InterviewCancellation = 'interview_cancellation',
  InterviewConfirmation = 'interview_confirmation',
  InterviewReminder = 'interview_reminder',
  LostLoopReactivation = 'lost_loop_reactivation',
  MatchesMail = 'matches_mail',
  StatusQueryFinal = 'status_query_final',
  StatusQueryHt = 'status_query_ht',
  StatusQueryOne = 'status_query_one',
  StatusQueryTwo = 'status_query_two',
  StatusQueryVt = 'status_query_vt',
  UnsolicitedMatch = 'unsolicited_match',
  VacancyRequest = 'vacancy_request',
}
